var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_44_813",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_44_813",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAABdElEQVR4nO3ZPU7DQBgG4SEFgYJzp0EU6dJxBoqIE9EhIRREaQrHFJEc/8T+dr2eR3KX4t3RFpYDkiRJkiRJkiRJUpQt8Ax8AifgADwmXVSgLXAEqovnkHJUadoiV8B3wl1FuRa5Ar7STStHV+QKeEm2rhB9Ih/Pv9NI98Ab1yO/Aw+pBpbAyAGMHMDIAYwcwMgBjBzAyAGMHMDIAYwcwMgBjBzAyAGMHMDIAYwcwMgBjBxg8ZE3wF3qER0W/UfqE/AK/AI/wJ48hy46MtSRcx+8+Mgb6puc8/DFR4Y69Il8D1BE5MaePA9SVGTI80A5bppETu+mOW2ZRQ4HzGFDiJQHXU3kRooDry5yI/Lgq43ciAiw+siNOUMY+cIcQYzcYsowRu4wRSAj93RLKCMPNCaYkUcaEs7IN+r7ha3Ir3DR+txWb/JExsY28ghDYxv5Bn1jG3kCXbGNPKG22EaewRbYAR/nZ4evcJIkSZIkSZIkSfr3Byj9YQPriG8CAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneBlack);
export default __webpack_public_path__ + "static/media/done_black.302734a6bfd3f35bfe57fa0c803f2d27.svg";
export { ForwardRef as ReactComponent };